import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Home, Building2, Receipt, CircleUserRound, LayoutGrid, ShoppingCart } from 'lucide-react';
import { useT } from '../utils/translate';
import { mediaUrl } from '../utils/media';
import LangDropdown from './LangDropdown';

// Mijoz-ilovaning umumiy qobig'i (header + pastki tab-navigatsiya) — har bir
// sahifa (Bosh sahifa/Katalog/Akt-sverka/Profil) endi O'Z ROUTE'iga ega
// (avval bittagina "/" ostida ichki `tab` state bilan almashtirilardi — orqaga
// tugmasi/havola ulashish ishlamas edi). Bu Layout <Outlet/> orqali joriy
// route'ning sahifasini shu qobiq ichida ko'rsatadi.
export default function Layout() {
  const t = useT();
  const navigate = useNavigate();
  const location = useLocation();
  const customer = useSelector((s) => s.auth.customer);
  const cartCount = useSelector((s) => s.cart.items.reduce((n, i) => n + i.qty, 0));
  const ordersEnabled = !!customer?.organization?.ordersEnabled;

  const TABS = [
    { path: '/',        label: t('home.navHome'),    icon: Home },
    { path: '/catalog', label: t('home.navCatalog'), icon: LayoutGrid },
    ...(ordersEnabled ? [{ path: '/cart', label: t('home.navCart'), icon: ShoppingCart, badge: cartCount }] : []),
    { path: '/akt',     label: t('home.navAkt'),      icon: Receipt },
  ];

  return (
    <div className="h-screen-safe md:max-w-xl md:mx-auto md:border-x md:border-surface-200 flex flex-col bg-surface-50 overflow-hidden">
      <div className="shrink-0 flex items-center justify-between gap-2 px-4 pb-5 bg-primary-700 safe-top [--safe-pad:1.25rem]">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center overflow-hidden bg-white/15 shrink-0">
            {customer?.organization?.logo
              ? <img src={mediaUrl(customer.organization.logo)} alt="" className="w-full h-full object-cover" />
              : <Building2 className="w-6 h-6 text-white" />}
          </div>
          <span className="font-semibold text-lg text-white truncate">{customer?.organization?.name || t('home.defaultTitle')}</span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <LangDropdown dark />
          <button onClick={() => navigate('/profile')} title={t('home.navProfile')}
            className={`p-2 rounded-lg text-white transition-colors ${location.pathname === '/profile' ? 'bg-white/25' : 'bg-white/10 hover:bg-white/20'}`}>
            <CircleUserRound className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>

      <nav className={`shrink-0 grid border-t border-surface-200 bg-white safe-bottom`} style={{ gridTemplateColumns: `repeat(${TABS.length}, minmax(0,1fr))` }}>
        {TABS.map(({ path, label, icon: Icon, badge }) => (
          <button
            key={path}
            onClick={() => navigate(path)}
            className={`relative flex flex-col items-center gap-1 py-2.5 text-xs font-medium transition-colors ${
              location.pathname === path ? 'text-primary-600' : 'text-ink-tertiary'
            }`}
          >
            <span className="relative">
              <Icon className="w-5 h-5" />
              {!!badge && (
                <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-primary-600 text-white text-[10px] font-semibold flex items-center justify-center">
                  {badge}
                </span>
              )}
            </span>
            {label}
          </button>
        ))}
      </nav>
    </div>
  );
}
